export * from "./glTFLoaderAnimation.pure";

import { RegisterGLTFLoaderAnimation } from "./glTFLoaderAnimation.pure";

RegisterGLTFLoaderAnimation();
